export interface Game {
  id: number;
  name: string;
  category: string;
  imageUrl: string;
  rating: number;
  players: number;
  isHot: boolean;
  isNew: boolean;
  tags: string[];
}

export const games: Game[] = [
  {
    id: 1,
    name: '金狮狂舞',
    category: 'dianzi-youxi',
    imageUrl: 'https://readdy.ai/api/search-image?query=Golden%20lion%20slot%20machine%20game%20screen%20with%20luxurious%20gold%20and%20red%20Chinese%20themed%20design%2C%20ornate%20golden%20frame%2C%20warm%20amber%20glow%2C%20dark%20elegant%20background%2C%20rich%20textures&width=400&height=300&seq=game-golden-lion&orientation=landscape',
    rating: 4.8,
    players: 12560,
    isHot: true,
    isNew: false,
    tags: ['热门', '高赔率'],
  },
  {
    id: 2,
    name: '幸运777',
    category: 'dianzi-youxi',
    imageUrl: 'https://readdy.ai/api/search-image?query=Classic%20slot%20machine%20with%20lucky%20sevens%20and%20cherries%2C%20vintage%20casino%20style%20with%20golden%20accents%2C%20dark%20velvet%20background%2C%20neon%20lighting%20effects&width=400&height=300&seq=game-lucky-777&orientation=landscape',
    rating: 4.6,
    players: 8930,
    isHot: true,
    isNew: false,
    tags: ['热门', '经典'],
  },
  {
    id: 3,
    name: '龙腾虎跃',
    category: 'dianzi-youxi',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20dragon%20and%20tiger%20themed%20slot%20game%20with%20red%20and%20gold%20ornate%20design%2C%20traditional%20Chinese%20patterns%2C%20mythical%20creatures%2C%20dark%20luxurious%20background%20with%20lanterns&width=400&height=300&seq=game-dragon-tiger&orientation=landscape',
    rating: 4.9,
    players: 15200,
    isHot: true,
    isNew: true,
    tags: ['热门', '新品', '高赔率'],
  },
  {
    id: 4,
    name: '深海探宝',
    category: 'dianzi-youxi',
    imageUrl: 'https://readdy.ai/api/search-image?query=Underwater%20treasure%20themed%20slot%20game%20with%20coral%20reefs%20and%20gold%20coins%2C%20deep%20blue%20ocean%20background%2C%20bubbles%20and%20pearls%2C%20elegant%20gaming%20interface&width=400&height=300&seq=game-ocean-treasure&orientation=landscape',
    rating: 4.5,
    players: 6780,
    isHot: false,
    isNew: false,
    tags: ['休闲'],
  },
  {
    id: 5,
    name: '财神到',
    category: 'dianzi-youxi',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20god%20of%20wealth%20themed%20casino%20game%20with%20gold%20ingots%20and%20red%20envelopes%2C%20traditional%20Chinese%20New%20Year%20elements%2C%20festive%20red%20and%20gold%20color%20scheme&width=400&height=300&seq=game-wealth-god&orientation=landscape',
    rating: 4.7,
    players: 10200,
    isHot: true,
    isNew: false,
    tags: ['热门', '高赔率'],
  },
  {
    id: 6,
    name: '埃及秘境',
    category: 'dianzi-youxi',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Egypt%20themed%20slot%20game%20with%20pyramids%20and%20pharaoh%20gold%20masks%2C%20mysterious%20desert%20atmosphere%2C%20hieroglyphics%20decorations%2C%20dark%20sand%20colored%20background&width=400&height=300&seq=game-egypt-mystery&orientation=landscape',
    rating: 4.4,
    players: 5430,
    isHot: false,
    isNew: true,
    tags: ['新品', '冒险'],
  },
  {
    id: 7,
    name: '极速百家乐',
    category: 'zhenren-heguan',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20live%20dealer%20baccarat%20table%20with%20elegant%20casino%20setting%2C%20green%20felt%20table%20with%20cards%2C%20Asian%20female%20dealer%20in%20formal%20attire%2C%20warm%20ambient%20lighting&width=400&height=300&seq=live-baccarat&orientation=landscape',
    rating: 4.9,
    players: 18500,
    isHot: true,
    isNew: false,
    tags: ['热门', '真人'],
  },
  {
    id: 8,
    name: '欧洲轮盘',
    category: 'zhenren-heguan',
    imageUrl: 'https://readdy.ai/api/search-image?query=European%20roulette%20table%20with%20live%20dealer%20spinning%20the%20wheel%2C%20elegant%20casino%20ambiance%2C%20red%20and%20black%20betting%20layout%2C%20professional%20dealer%20in%20tuxedo&width=400&height=300&seq=live-roulette&orientation=landscape',
    rating: 4.8,
    players: 12300,
    isHot: true,
    isNew: false,
    tags: ['热门', '真人', '经典'],
  },
  {
    id: 9,
    name: '骰宝争霸',
    category: 'zhenren-heguan',
    imageUrl: 'https://readdy.ai/api/search-image?query=Live%20Sic%20Bo%20dice%20game%20table%20with%20Chinese%20themed%20decor%2C%20professional%20Asian%20dealer%2C%20red%20and%20gold%20table%20layout%2C%20dice%20in%20glass%20container&width=400&height=300&seq=live-sicbo&orientation=landscape',
    rating: 4.7,
    players: 8760,
    isHot: false,
    isNew: false,
    tags: ['真人', '骰子'],
  },
  {
    id: 10,
    name: '德州扑克大师',
    category: 'zhenren-heguan',
    imageUrl: 'https://readdy.ai/api/search-image?query=Texas%20Holdem%20poker%20table%20with%20professional%20dealer%2C%20playing%20cards%20and%20chips%2C%20dark%20green%20felt%20table%2C%20elegant%20casino%20lighting&width=400&height=300&seq=live-poker&orientation=landscape',
    rating: 4.6,
    players: 6540,
    isHot: false,
    isNew: false,
    tags: ['真人', '扑克'],
  },
  {
    id: 11,
    name: '英超焦点战',
    category: 'tiyu-jingji',
    imageUrl: 'https://readdy.ai/api/search-image?query=English%20Premier%20League%20soccer%20match%20intense%20action%20with%20players%20celebrating%20goal%2C%20stadium%20floodlights%2C%20green%20pitch%2C%20dramatic%20sports%20photography&width=400&height=300&seq=sports-epl&orientation=landscape',
    rating: 4.5,
    players: 21000,
    isHot: true,
    isNew: false,
    tags: ['热门', '足球'],
  },
  {
    id: 12,
    name: 'NBA季后赛',
    category: 'tiyu-jingji',
    imageUrl: 'https://readdy.ai/api/search-image?query=NBA%20basketball%20playoff%20intense%20dunk%20moment%2C%20professional%20basketball%20player%20in%20action%2C%20arena%20lights%2C%20dramatic%20sports%20atmosphere&width=400&height=300&seq=sports-nba&orientation=landscape',
    rating: 4.7,
    players: 16800,
    isHot: true,
    isNew: false,
    tags: ['热门', '篮球'],
  },
  {
    id: 13,
    name: '网球大满贯',
    category: 'tiyu-jingji',
    imageUrl: 'https://readdy.ai/api/search-image?query=Grand%20Slam%20tennis%20match%20with%20player%20serving%2C%20professional%20tennis%20court%2C%20dramatic%20lighting%2C%20clay%20court%20surface&width=400&height=300&seq=sports-tennis&orientation=landscape',
    rating: 4.3,
    players: 4320,
    isHot: false,
    isNew: false,
    tags: ['网球'],
  },
  {
    id: 14,
    name: '快乐8',
    category: 'caipiao-youxi',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20lottery%20game%20interface%20with%20numbered%20balls%20and%20golden%20design%2C%20red%20and%20gold%20color%20scheme%2C%20lucky%20numbers%20display&width=400&height=300&seq=lottery-happy8&orientation=landscape',
    rating: 4.5,
    players: 7800,
    isHot: true,
    isNew: false,
    tags: ['热门', '高频'],
  },
  {
    id: 15,
    name: '时时彩',
    category: 'caipiao-youxi',
    imageUrl: 'https://readdy.ai/api/search-image?query=Real%20time%20lottery%20game%20with%20flashing%20numbers%20and%20countdown%20timer%2C%20modern%20digital%20display%2C%20gold%20and%20dark%20theme&width=400&height=300&seq=lottery-ssc&orientation=landscape',
    rating: 4.4,
    players: 6500,
    isHot: false,
    isNew: false,
    tags: ['高频', '快速'],
  },
  {
    id: 16,
    name: '英雄联盟全球总决赛',
    category: 'dianjing-jingji',
    imageUrl: 'https://readdy.ai/api/search-image?query=League%20of%20Legends%20esports%20championship%20stage%20with%20teams%20competing%2C%20massive%20arena%20with%20colorful%20lights%2C%20professional%20gaming%20atmosphere&width=400&height=300&seq=esports-lol&orientation=landscape',
    rating: 4.8,
    players: 25000,
    isHot: true,
    isNew: false,
    tags: ['热门', 'MOBA'],
  },
  {
    id: 17,
    name: 'DOTA2国际邀请赛',
    category: 'dianjing-jingji',
    imageUrl: 'https://readdy.ai/api/search-image?query=DOTA2%20The%20International%20esports%20tournament%20grand%20stage%2C%20professional%20teams%20competing%2C%20epic%20arena%20atmosphere&width=400&height=300&seq=esports-dota2&orientation=landscape',
    rating: 4.7,
    players: 18900,
    isHot: true,
    isNew: false,
    tags: ['热门', 'MOBA'],
  },
  {
    id: 18,
    name: '首存大礼包',
    category: 'youhui-huodong',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxurious%20gift%20box%20with%20golden%20ribbon%20on%20dark%20elegant%20background%2C%20sparkling%20gold%20particles%2C%20Chinese%20red%20and%20gold%20decorative%20elements&width=400&height=300&seq=promo-first-deposit&orientation=landscape',
    rating: 4.9,
    players: 32000,
    isHot: true,
    isNew: true,
    tags: ['热门', '新人', '高额'],
  },
  {
    id: 19,
    name: '每日返水',
    category: 'youhui-huodong',
    imageUrl: 'https://readdy.ai/api/search-image?query=Golden%20coins%20stacked%20with%20percentage%20symbol%2C%20dark%20luxurious%20background%20with%20soft%20gold%20glow%2C%20cashback%20concept&width=400&height=300&seq=promo-daily-rebate&orientation=landscape',
    rating: 4.8,
    players: 28500,
    isHot: true,
    isNew: false,
    tags: ['热门', '返水'],
  },
  {
    id: 20,
    name: 'VIP尊享礼遇',
    category: 'youhui-huodong',
    imageUrl: 'https://readdy.ai/api/search-image?query=VIP%20membership%20golden%20card%20with%20crown%20icon%2C%20dark%20luxurious%20setting%20with%20velvet%20and%20gold%20elements&width=400&height=300&seq=promo-vip&orientation=landscape',
    rating: 4.7,
    players: 15000,
    isHot: false,
    isNew: false,
    tags: ['VIP', '专属'],
  },
];

export const getGamesByCategory = (slug: string): Game[] => {
  return games.filter((g) => g.category === slug);
};

export const getGameById = (id: number): Game | undefined => {
  return games.find((g) => g.id === id);
};

export const getHotGames = (): Game[] => {
  return games.filter((g) => g.isHot);
};

export const getNewGames = (): Game[] => {
  return games.filter((g) => g.isNew);
};